import { render, staticRenderFns } from "./BankResource.vue?vue&type=template&id=95f8fd32&"
import script from "./BankResource.vue?vue&type=script&lang=js&"
export * from "./BankResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports